// extracted by mini-css-extract-plugin
module.exports = {"balance":"AccountBalance-module__balance--1f_mZ","noBalance":"AccountBalance-module__noBalance--1256b"};